import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { closeNotification } from '../../../store/actions/notificationsActions';
import { Link } from 'react-router-dom';
import { compose } from 'recompose';

const styles = {
  subscribeButton: {
    height: 40,
    margin: 10
  },
  emailInput: {
    height: 3
  },
  modalStyles: {
    width: '300px',
    height: '200px'
  },
  success: {
    backgroundColor: 'green'
  },
  error: {
    backgroundColor: 'red'
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  },
  linkText: {
    '& > a': {
      cursor: 'pointer',
      textDecoration: 'underline'
    },
    '& > .linkClass': {
      cursor: 'pointer',
      textDecoration: 'underline !important'
    }
  },
  iconStyle: {
    marginRight: '7px'
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  linkClass: {
    textDecoration: 'underline',
    cursor: 'pointer'
  }
};

class Notification extends Component {
  handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    this.props.handlecloseNotification();
  }

  render() {
    const { classes, message, open, variant } = this.props;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        open={open}
        autoHideDuration={6000}
        onClose={this.handleClose.bind(this)}
      >
        <SnackbarContent
          className={`${
            variant === 'success' ? classes.success : classes.error
          }`}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
              {variant === 'success' && (
                <CheckCircleIcon className={classes.iconStyle} />
              )}
              {variant === 'error' && (
                <ErrorIcon className={classes.iconStyle} />
              )}
              <div
                className={classes.linkText}
                dangerouslySetInnerHTML={{ __html: message }}
              ></div>
              {/* {message} */}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={`${
                variant === 'success' ? classes.success : classes.error
              }`}
              onClick={this.handleClose.bind(this)}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
      </Snackbar>
    );
  }
}

const mapStateToProps = state => {
  return {
    message: state.notifications.message,
    open: state.notifications.open,
    variant: state.notifications.variant
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handlecloseNotification: () => dispatch(closeNotification())
  };
};

Notification.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.string
};

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
//   withStyles(styles)
// )(Notification);

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Notification);



// WEBPACK FOOTER //
// ./src/components/shared/components/Notification.js